import { FETCH_LOGIN, LOGIN_SUCCESS, LOGIN_FAILS, REMOVE_AUTH_DETAILS} from './authActionTypes';

export const authReducer = (
    state = {
            fetching: false,
            error: { status: false, message: "" },
            data: [],
            isRemoveAuth : false
}, action) => {
    switch (action.type) {
          
        case FETCH_LOGIN:
            return Object.assign({}, state, { fetching: true, isRemoveAuth : false });
        
        case LOGIN_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: { status: false, message: "" },
                data: action.payload?.data || []
                        
            };
        
        case LOGIN_FAILS:
            return {
                ...state,
                fetching: false,
                error: { status: true, message: 'login fails' },
                data: []
                        
            };

        case REMOVE_AUTH_DETAILS:
            return {
                ...state,
                fetching: false,
                error: { status: false, message: "" },
                data: [],
                isRemoveAuth : true
                            
        };
        
        default:
            return state;
    }
};